import moment from 'moment/moment';
import If from 'Views/Components/If/If';
import * as React from 'react';
import { AlaresReport } from 'Models/Interfaces/AlaresReport';
import { formatDateString } from 'Util/StringUtils';

const AdverseAlertsAbrSummary = (props: {
	alaresReport?: AlaresReport,
}) => {
	const { alaresReport } = props;

	const asicRegistrationDate = formatDateString(alaresReport?.asic_date_of_registration);
	const gstFromDate = formatDateString(alaresReport?.abn_gst_registration_date);
	const trusteeAsicRegistrationDate = formatDateString(alaresReport?.trustee_asic_date_of_registration)

	const abnAddress = alaresReport?.abn_state && alaresReport?.abn_postcode
		? `${alaresReport?.abn_state} ${alaresReport?.abn_postcode}`
		: undefined;

	return (
		<div className="section abr-summary">
			<div className="fields">
				<AdverseAlertBusinessDisplayValue title={"ASIC status"} value={alaresReport?.asic_status} />
				<AdverseAlertBusinessDisplayValue title={"ASIC registration date"} value={asicRegistrationDate} />

				<If condition={!!alaresReport?.trustee_asic_status}>
					<AdverseAlertBusinessDisplayValue title={"Trustee ASIC status"} value={alaresReport?.trustee_asic_status} />
				</If>

				<If condition={!!alaresReport?.trustee_asic_date_of_registration}>
					<AdverseAlertBusinessDisplayValue title={"Trustee ASIC registration date"} value={trusteeAsicRegistrationDate} />
				</If>

				<AdverseAlertBusinessDisplayValue title={"GST from date"} value={gstFromDate} />
			</div>
			<div className="fields">
				<AdverseAlertBusinessDisplayValue title={"ABN status"} value={alaresReport?.abn_status} />
				<AdverseAlertBusinessDisplayValue title={"ABN state & postcode"} value={abnAddress} />
				<AdverseAlertBusinessDisplayValue title={"GST status"} value={alaresReport?.abn_gst_status} />
			</div>
		</div>
	);
};

// Sugar wrapper component for displaying a label and value
function AdverseAlertBusinessDisplayValue(props: {
	title: string,
	value?: string | null
}) {

	const { title, value } = props;
	const defaultEmptyText = "-";
	return <p className="field"><b>{title}:</b> {value ?? defaultEmptyText}</p>
}

export default AdverseAlertsAbrSummary;
